import angular, { ILogService, ITimeoutService } from 'angular'
import { Dictionary, keyBy } from 'lodash'
import { AccesoDatos } from 'src/_candidato/comun/services/acceso-datos'
import { NotificacionService } from 'src/_panel/module/uni-base/services/NotifService'
import { IGestionTexto, IKeyTextos, IModelText, ITextosPorKey } from 'src/model/candidato-api'

class PanelIntroComponentCtrl {
  $loading = false
  $ready = false

  textos: ITextosPorKey | null = null

  textosIntro: { [lang: string]: IModelText } = {}

  constructor(
    private $timeout: ITimeoutService,
    private $log: ILogService,
    private NotifService: NotificacionService,
    private AccesoDatos: AccesoDatos
  ) {}

  $onInit(): void {
    this.$log.info('[PanelIntroComponentCtrl] onInit')
  }

  $postLink() {
    // para dar tiempo a inicializarse materialize
    this._leerTextos()
  }

  private _leerTextos() {
    this.$loading = true

    this.AccesoDatos.GestionTextos_CLIENT.textos().then((textosResponse) => {
      this.textos = textosResponse

      this.textosIntro = this._initTextos('INTRO', this.textos.porKey.INTRO || [])

      this.$loading = false

      this.$timeout(() => (this.$ready = true), 100)
    })
  }

  private _initTextos(key: IKeyTextos, textos: IModelText[]) {
    function initLang(_textosLang: Dictionary<IModelText>, textlng: string) {
      if (!_textosLang[textlng]) {
        _textosLang[textlng] = {
          textkey: key,
          text: '',
          textlng,
        } as IModelText
      }
    }

    // buscar el registro para es y para en
    let textosLang = keyBy(textos, (t) => t.textlng) || {}

    // asegurar inicialización para es y para en
    initLang(textosLang, 'es')
    initLang(textosLang, 'en')

    return textosLang
  }

  saveTextosIntro() {
    if (this.$loading) return

    let dto: IGestionTexto = {
      registros: [this.textosIntro['es'], this.textosIntro['en']],
    }

    this.$loading = true
    this.AccesoDatos.GestionTextos_CLIENT.actualizaTextos(dto).then((textosResponse) => {
      // actualizar los textos si ya estaban guardados
      this.textosIntro = this._initTextos('INTRO', textosResponse || [])

      this.$loading = false
    })
  }
}

angular.module('candidato').component('panelIntro', {
  bindings: {
    // empresa: "<",
  },
  controller: PanelIntroComponentCtrl,
  // templateUrl: "panel-intro.component.html",
  template: require('./panel-intro.component.html'),
})
